import { titleGradient } from '@/lib/utils';

/**
 * The 16:5 header block for a module. One uploaded image, cropped wide here;
 * the same asset is the list thumb. No image → deterministic gradient, so an
 * un-authored module still looks intentional.
 *
 * `as` is the heading level of the overlaid title. On the course page the
 * banner is one of many, under the course's own h1, so it stays an h2. On the
 * module page it IS the page title, so that caller asks for an h1.
 */
export function ModuleBanner({
  title,
  imageUrl,
  as: Heading = 'h2',
}: {
  title: string;
  imageUrl: string | null;
  as?: 'h1' | 'h2';
}) {
  return (
    <div
      className="relative flex aspect-[16/5] items-end overflow-hidden rounded-xl shadow-soft"
      style={imageUrl ? undefined : { backgroundImage: titleGradient(title) }}
    >
      {imageUrl && (
        <img
          src={imageUrl}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          draggable={false}
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-transparent" />
      <Heading className="relative z-10 line-clamp-2 p-4 text-xl font-semibold text-white drop-shadow-sm">
        {title}
      </Heading>
    </div>
  );
}
